import algoliasearch from 'algoliasearch'
import { ALGOLIA_API_KEY_SEARCH, ALGOLIA_APP_ID } from '../env.config'

export const searchClient = algoliasearch(
  ALGOLIA_APP_ID,
  ALGOLIA_API_KEY_SEARCH
)
